package com.milta.feature.route.domain.entity

/** One stop of a route detail (MIL-38 — `GET /routes/{id}`'s `deliveries[]`). */
data class Delivery(
    val id: String,
    val sortOrder: Int,
    val recipientName: String,
    val address: String,
    val status: DeliveryStatus,
    // MIL-45 — lets the Gestionnaire see which stops still lack GPS coordinates.
    val geocodeStatus: GeocodeStatus,
    // Same raw-timestamp-string convention as RouteStop.deliveryTimeLimit (RouteSummary.kt) — not a
    // real UTC instant, the backend stamps the configured deadline time onto the route's own date;
    // format for display with "HH:mm" extraction (substringAfter('T', "").take(5)), never parsed as
    // an actual Instant.
    val deliveryTimeLimit: String?,
    val packageCount: Int,
    /** Retour 26/10 (R1/R11) — why HERE refused [address] (Failed only), null otherwise. */
    val geocodeFailureReason: GeocodeFailureReason? = null,
    /** Retour 29/10 — the address HERE matched ("Trouvée : …"), null when not reported (older data). */
    val resolvedAddress: String? = null,
    /** Réunion 28/10 (point 5) — real validation time (ISO 8601 with offset), Completed/Failed only. */
    val completedAt: String? = null,
    val phoneNumber: String? = null,
)
